// extracted by mini-css-extract-plugin
module.exports = {"more-box":"MoreBox_more-box__2kVaC","more":"MoreBox_more__2T5Xy"};